import React, {Fragment, useState, useEffect, useMemo, useCallback} from 'react'
import {useDispatch, useSelector} from "react-redux"

// Material-UI Cord
import {makeStyles, withStyles} from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Tooltip from '@material-ui/core/Tooltip'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import Fab from '@material-ui/core/Fab'
import Box from '@material-ui/core/Box'

// Material-UI Lab
import Autocomplete from '@material-ui/lab/Autocomplete'
import ToggleButton from '@material-ui/lab/ToggleButton'
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup'

// Material-UI Icon
import AddIcon from '@material-ui/icons/Add'

// Material-UI Element
//import {MuiPickersUtilsProvider, KeyboardDatePicker} from "@material-ui/pickers"

// Custom Component
import {Alert} from '../Alert/Alert'
import ConfirmDialog from '../Dialog/ConfirmDialog'
import FullScreenDialog from "../Dialog/FullScreenDialog"
import Legend from '../Legend/Legend'
import Efiling from '../../views/Efiling/Efiling.js'
import RelatedItemFileZoneContent from './RelatedItemFileZoneContent'
import FileDropzone from '../FileDropzone/FileDropzone'
import FilePreview from '../FilePreview/FilePreview'
import WebViewer from '../WebViewer/WebViewer'

// Custom Style
import {redColor, oceanBlueColor, grayColor, blackColor, DodgerBlueColor} from '../../styles/jss/cmsMainStyle'
import {createRelatedItemFormStyle} from '../../styles/jss/components/drawingRegister/createRelatedItemFormStyle'

// Global Function
import {getFile} from "../../global/getPropertyInfo"

// Fetch Data
import {getRelatedItemType, getRelatedItemAllType, getCoverType, getCompanyList, createUnpublish, createRelatedItem, getRelatedItemsDetail} from '../../dataSource/drawingRegister'
import {fileUpload} from '../../dataSource/fileManager'


// Custom Style (Typography)
// const InboxTypography = withStyles({
// 	root: {
// 		"fontSize": 12,
// 		"fontWeight": 400,
// 		"color": "red",
// 	},
// }) (Typography)


const useStyles = makeStyles(theme => createRelatedItemFormStyle(theme))

const CreateRelatedItemForm = props => {
	const {relatedItemType, createMethod, drawingDetailRecord, selectedRevisionSeq, setRelatedItemSaveResult, dialogHandleClose, setRelatedItemRefash} = props
	const classes = useStyles()
	const dispatch = useDispatch()

	// Redux Variable
	const propertySeqRedux = useSelector(state => state.propertySeqRedux)
	const fileUploadingPropertyRedux = useSelector(state => state.fileUploadingPropertyRedux)

	// State Variable
	const [relatedItemTypeRecord, setRelatedItemTypeRecord] = useState(null)
	const [companyList, setCompanyList] = useState(null)
	const [relatedItemProperty, setRelatedItemProperty] = useState(null)
	const [selectedRelatedItemType, setSelectedRelatedItemType] = useState(null)
	const [selectedInOut, setSelectedInOut] = useState(null)
	const [webViewProps, setWebViewProps] = useState(null)
	const [filePreviewProperty, SetFilePreviewProperty] = useState(null)
	const [propertyFiles, setPropertyFiles] = useState(null)
	const [validationErrors, setValidationErrors] = useState({})
	const [fileUploadingProperty, setFileUploadingProperty] = useState([])

	// Dialog contral state
	const [fileManagerDialogOpen, setFileManagerDialogOpen] = useState(false)
	const [filePreviewDialogOpen, setFilePreviewDialogOpen] = useState(false)

	// Alert dialog contral state
	const [alertOpen, setAlertOpen] = useState(false)
	const [alertData, setAlertData] = useState({
		type: "",
		title: "",
		content: ""
	})

	// Confirm dialog contral State
	const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)
	const [confirmDialogData, setConfirmDialogData] = useState({
		dialogTitle: "",
		dialogContent: "",
		confirmAction: "",
		cancelAction: ""
	})

	// Template Define 
	const relatedItemPropertyTemplate = {
		type_seq: null,
		rel_no: "",
		files: [],
		rel_desc: "",
		inout: "",
		company_seq: null
	}


	// Set Alert Content
	const buildAlert = (data) => {
		setAlertData({
			type: data.type,
			title: data.title,
			content: data.content
		})
		setAlertOpen(true)
	}

	// Set Confirm Dialog Content
	const buildConfirmDialog = (data) => {
		setConfirmDialogData({
			dialogTitle: data.dialogTitle,
			dialogContent: data.dialogContent,
			confirmAction: data.confirmAction,
			cancelAction: data.cancelAction
		})
	}


	// Input Handle
	const handleRelatedType = (event, selectedValue) => {
		setValidationErrors({})
		setSelectedRelatedItemType(selectedValue)

		const res = {...relatedItemProperty}
		res.type_seq = selectedValue ? selectedValue.relative_type_seq : null

		setRelatedItemProperty(res)
		dispatch({
			type: "ADD_RELATED_ITEM",
			data: res
		})
	}

	// const handleInOut = (event, selectedValue) => {
	// 	setValidationErrors({})
	// 	setSelectedInOut(selectedValue)
	// 	setCompanyList(selectedValue ? selectedRelatedItemType.inout_map[selectedValue].companies : null)

	// 	const res = {...relatedItemProperty}
	// 	res.inout = selectedValue ? selectedValue : null

	// 	setRelatedItemProperty(res)
	// 	dispatch({
	// 		type: "ADD_RELATED_ITEM",
	// 		data: res
	// 	})
	// }

	// const handleCompanyChange = (event, value) => {
	// 	const res = {...relatedItemProperty}
	// 	res.company_seq = value ? value.company_seq : null

	// 	setRelatedItemProperty(res)
	// 	dispatch({
	// 		type: "ADD_RELATED_ITEM",
	// 		data: res
	// 	})

	// 	// validate(res)
	// }

	const handleTextChange = event => {
		const {name, value} = event.target
		const res = {...relatedItemProperty}
		res[name] = value

		setRelatedItemProperty(res)
		dispatch({
			type: "ADD_RELATED_ITEM",
			data: res
		})

		validate(res)
	}


	// Confirm Dialog Contral Function
	const confirmDialogHandleOpen = (data) => {
		buildConfirmDialog(data)
		setConfirmDialogOpen(true)
	}

	const confirmDialogHandleClose = () => {
		setConfirmDialogOpen(false)
	}


	// Dialog Contral Function
	const fileManagerDialogHandleOpen = () => {
		setFileManagerDialogOpen(true)
	}

	const fileManagerDialogHandleClose = () => {
		// clearFileChoice()
		setFileManagerDialogOpen(false)
	}

	const filePreviewDialogHandleOpen = () => {
		setFilePreviewDialogOpen(true)
	}

	const filePreviewDialogHandleClose = () => {
		setFilePreviewDialogOpen(false)
	}


	// Dialog Button Function
	const fileManagerFileSelected = async () => {
		if (propertySeqRedux === null) {
			buildAlert({
				// Alert Type: success, info, warning, error
				type: "warning",
				title: "Warning Alert",
				content: "Not any file choice, Please choice the file first."
			})

			return
		}

		if (propertySeqRedux.length === 0) {
			buildAlert({
				// Alert Type: success, info, warning, error
				type: "warning",
				title: "Warning Alert",
				content: "Not any file choice, Please choice the file first."
			})

			return
		}

		setPropertyFiles(await getFile(propertySeqRedux))
		fileManagerDialogHandleClose()
	}


	const fileUploadAction = (fileType, acceptedFilesPool) => {
		let UploadingSource = buildFileUploadingProperty(acceptedFilesPool)

		acceptedFilesPool.map(file => {
			fileUpload(file).then(res => {
				console.log("*****************************************************************************")
				console.log("Temporary upload File Successful")
				console.log(res)
				console.log("*****************************************************************************")

				UploadingSource = removeFileUploadingProperty(UploadingSource, file)
				buildFileRecordFromHarddisk(fileType, res.data[0])
			})
		})
	}

	const buildFileUploadingProperty = fileUploadRecord => {
		const res = [...fileUploadingProperty, ...fileUploadRecord]

		setFileUploadingProperty(res)
		dispatch({
			type: "ADD_FILE_UPLOADING_PROPERTY",
			data: res
		})

		return res
	}


	const removeFileUploadingProperty = (sourceRecords, key) => {
		if (sourceRecords) {
			const res = sourceRecords.filter(sourceRecord => sourceRecord !== key)

			setFileUploadingProperty(res)
			dispatch({
				type: "ADD_FILE_UPLOADING_PROPERTY",
				data: res
			})

			return res
		}
	}

	const buildFileRecordFromHarddisk = (fileType, fileUploadRecord) => {
		const res = {...relatedItemProperty}
		res.files.push(fileUploadRecord)
		
		setRelatedItemProperty(res)
		dispatch({
			type: "ADD_RELATED_ITEM",
			data: res
		})

		validate(res)
	}

	const buildFileRecordFromEfiling = () => {
		let res = {...relatedItemProperty}
	
		if (propertyFiles !== null) {
			res.files.push(...propertyFiles)
		}

		setRelatedItemProperty({...relatedItemProperty, res})
		dispatch({
			type: "ADD_RELATED_ITEM",
			data: {...relatedItemProperty, ...res}
		})

		validate({...relatedItemProperty, ...res})
	}


	const viewFileAction = (fileCat, fileSeq, filename) => {
		setWebViewProps({
			file_cat: fileCat,
			file_ref: fileSeq,
			file_name: filename,
			from: "API",
			autoLoading: false,
		})
	}

	const removeFileAction = (fileRecord) => {
		let result
		let res = {...relatedItemProperty}

		result = [...relatedItemProperty.files].filter(res => res !== fileRecord)
		res.files = result

		setRelatedItemProperty({...relatedItemProperty, ...res})
		dispatch({
			type: "ADD_RELATED_ITEM",
			data: {...relatedItemProperty, ...res}
		})

		confirmDialogHandleClose()
	}

	const removeFileConfirmAction = (fileRecord) => {
		confirmDialogHandleOpen({
			dialogTitle: "Remove the drawing",
			dialogContent: "Are you sure to remove the file.",
			confirmAction: () => removeFileAction(fileRecord),
			cancelAction: removeFileCancelAction
		})
	}

	const removeFileCancelAction = () => {
		confirmDialogHandleClose()
	}

	const createRelatedItemConfirmAction = () => {
		if (validate()) {
			confirmDialogHandleOpen({
				dialogTitle: "Create Related Item",
				dialogContent: "Are you sure to create the related item.",
				confirmAction: () => createRelatedItemAction(),
				cancelAction: createRelatedItemCancelAction
			})
		}
	}


	const createRelatedItemCancelAction = () => {
		confirmDialogHandleClose()
	}


	const createRelatedItemAction = () => {
		createRelatedItem(drawingDetailRecord.dwg_seq, selectedRevisionSeq, relatedItemProperty).then(res => {

			if (createMethod == "IN_VIEWER") {
				setRelatedItemSaveResult(res.data[0])
			}

			if (createMethod == "IN_WEB") {
				setRelatedItemRefash(res.code)
			}

			confirmDialogHandleClose()
			buildAlert({
				// Alert Type: success, info, warning, error
				type: "success",
				title: "Success Alert",
				content: "The Related Item have been created."
			})
			
			dialogHandleClose()
		})
	}


	// Dialog Button
	const fileManagerDialogBtn = [
		{
			buttonName: "OK",
			buttonFunction: fileManagerFileSelected,
			chooseFile: false
		},
	]


	// Input Validation
	const validate = (fieldValues = relatedItemProperty) => {
		let temp = {...validationErrors}
	
		if ("rel_no" in fieldValues) {
			temp.rel_no = fieldValues.rel_no ? "" : "This field is required"
		}

		if ("rel_desc" in fieldValues) {
			temp.rel_desc = fieldValues.rel_desc ? "" : "This field is required"
		}

		if ("files" in fieldValues) {
			temp.files = fieldValues.files.length > 0 ? "" : "This field is required"
		}

		setValidationErrors({...temp})

		if (fieldValues == relatedItemProperty) {
			return Object.values(temp).every(x => x == "")
		}
	}


	useEffect(() => {
		buildFileRecordFromEfiling()
	}, [propertyFiles])

	
	useEffect(() => {
		setRelatedItemProperty(relatedItemPropertyTemplate)

		getRelatedItemType().then(res => {
			const tempType = []

			if (relatedItemType === "All") {
				res.map(typeGroup => {
					typeGroup.relative_types.map(type => {
						tempType.push(type)
					})
				})

				setRelatedItemTypeRecord(tempType)
			}
			else {
				res.map(typeGroup => {
					if (typeGroup.relative_type_group_name === relatedItemType) {
						setRelatedItemTypeRecord(typeGroup.relative_types)
					}
				})
			}
		})

	}, [])



	return (
		// console.log("Selected Revision Seq | Variable: selectedRevisionSeq (createRelatedItemForm.js)"),
		// console.log(selectedRevisionSeq),
		
		// console.log("Related Item Type | Variable: relatedItemType (createRelatedItemForm.js)"),
		// console.log(relatedItemType),

		// console.log("Related Item Type Record | Variable: relatedItemTypeRecord (createRelatedItemForm.js)"),
		// console.log(relatedItemTypeRecord),

		// console.log("Selected Related Item Type | Variable: setSelectedRelatedItemType (createRelatedItemForm.js)"),
		// console.log(selectedRelatedItemType),

		// console.log("Selected In / Out | Variable: selectedInOut (createRelatedItemForm.js)"),
		// console.log(selectedInOut),

		// console.log("Company List | Variable: companyList (createRelatedItemForm.js)"),
		// console.log(companyList),

		// console.log("Related Item Property | Variable: relatedItemProperty (createRelatedItemForm.js)"),
		// console.log(relatedItemProperty),

		// console.log("Related Item Property (Redux) | Variable: relatedItemPropertyRedux (createRelatedItemForm.js)"),
		// console.log(relatedItemPropertyRedux),

		// console.log("---------------------------------------------------------------------------------"),


		<Fragment>
			<div>
				<Alert
					open={alertOpen}
					alertType={alertData.type}
					alertTitle={alertData.title}
					alertContent={alertData.content}
					handleClose={() => setAlertOpen(false)}
				/>

				<ConfirmDialog
					open={confirmDialogOpen}
					dialogTitle={confirmDialogData.dialogTitle}
					dialogContent={confirmDialogData.dialogContent}
					confirmAction={confirmDialogData.confirmAction}
					cancelAction={confirmDialogData.cancelAction}
				/>

				<FullScreenDialog
					open={fileManagerDialogOpen}
					dialogTitle={"File Choice From eFiling"}
					formContent={
						<Efiling fileManagerType={"select"} />   // main => Main File Manager, select => Select File From File Manager
					}
					button={fileManagerDialogBtn}
					handleClose={fileManagerDialogHandleClose}
				/>

				<FullScreenDialog
					open={filePreviewDialogOpen}
					dialogTitle={"Drawing Preview"}
					formContent={
						<FilePreview 
							filePreviewProperty={filePreviewProperty}
						/>
					}
					button={[]}
					handleClose={filePreviewDialogHandleClose}
				/>
			</div>

			<Grid container spacing={1} className={classes.fieldGridArea}>
				<Grid item xs={12} sm={12} lg={4}>

					<Grid container spacing={1} className={classes.fieldGrid}>
						<Grid item xs={12} sm={12} lg={12}>
							<ToggleButtonGroup
								aria-label="Related Item Type"
								exclusive
								value={selectedRelatedItemType}
								onChange={handleRelatedType}
								className={classes.ToggleButtonGroup}
							>
								{
									relatedItemTypeRecord ?
										relatedItemTypeRecord.map((res, index) => {
											return (
												<ToggleButton
													key={index}
													aria-label={res.relative_type_name}
													value={res}
													className={classes.ToggleButton}
												>
													<Typography color="textSecondary">{res.relative_type_name}</Typography>
												</ToggleButton>
											)
										})
									: ""
								}
							</ToggleButtonGroup>
						</Grid>
					</Grid>

					{/* {
						selectedRelatedItemType ?
							selectedRelatedItemType.relative_type_name !== "Sketches" ?
								<Grid container spacing={1} className={classes.fieldGrid}>
									<Grid item xs={12} sm={12} lg={12}>
										<ToggleButtonGroup
											aria-label="Related In Out"
											exclusive
											value={selectedInOut}
											onChange={handleInOut}
											className={classes.ToggleButtonGroup}
										>
											<ToggleButton
												aria-label={"in"}
												value={"IN"}
												className={classes.ToggleButton_50}
											>
												<Typography color="textSecondary">IN</Typography>
											</ToggleButton>

											<ToggleButton
												aria-label={"out"}
												value={"OUT"}
												className={classes.ToggleButton_50}
											>
												<Typography color="textSecondary">OUT</Typography>
											</ToggleButton>
										</ToggleButtonGroup>
									</Grid>
								</Grid>
							: ""
						:""
					} */}

					{
						selectedRelatedItemType ?
							<div>
								{/* {
									selectedRelatedItemType.relative_type_name !== "Sketches" ?
										<Grid container spacing={1} className={classes.fieldGrid}>
											<Grid item xs={12} sm={12} lg={12}>
												<Autocomplete
													// multiple
													id="company_seq"
													name="company_seq"
													options={companyList ? companyList : []}
													getOptionLabel={option => option.company_name}
													onChange={(event, value) => {
														handleCompanyChange(event, value)
													}}
													renderInput={params => (
														<TextField
															{...params}
															required
															variant="outlined"
															label="Organization"
															size="small"
															value={relatedItemProperty ? relatedItemProperty.company_seq : ""}
															InputLabelProps={{
																shrink: true,
															}}
															error={validationErrors.company_seq && validationErrors.company_seq !== "" ? true : false}
															helperText={validationErrors.company_seq}
														/>
													)}
												/>
											</Grid>
										</Grid>
									: ""
								} */}

								<Grid container spacing={1} className={classes.fieldGrid}>
									<Grid item xs={12} sm={12} lg={12}>
										<TextField
											id="rel_no"
											name="rel_no"
											label="Ref No."
											required
											fullWidth={true}
											size="small"
											variant="outlined"
											value={relatedItemProperty ? relatedItemProperty.rel_no : ""}
											onChange={handleTextChange}
											InputLabelProps={{
												shrink: true,
											}}
											error={validationErrors.rel_no && validationErrors.rel_no !== "" ? true : false}
											helperText={validationErrors.rel_no}
										/>
									</Grid>
								</Grid>

								<Grid container spacing={1} className={classes.fieldGrid}>
									<Grid item xs={12} sm={12} lg={12}>
										<TextField
											id="rel_desc"
											name="rel_desc"
											label="Description"
											required
											fullWidth={true}
											size="small"
											variant="outlined"
											value={relatedItemProperty ? relatedItemProperty.rel_desc : ""}
											onChange={handleTextChange}
											InputLabelProps={{
												shrink: true,
											}}
											error={validationErrors.rel_desc && validationErrors.rel_desc !== "" ? true : false}
											helperText={validationErrors.rel_desc}
										/>
									</Grid>
								</Grid>

								<div className={classes.LegendArea}>
									<Legend
										id="files"
										label="File Upload *"
										required={true}
										normalTitleColor={grayColor[10]}
										normalBorderColor={grayColor[4]}
										messageTitleColor={redColor[6]}
										messageBorderColor={redColor[6]}
										error={validationErrors.files && validationErrors.files !== "" ? true : false}
										helperText={validationErrors.files}
									>
										<Box className={classes.addFileBtnArea}>
											<FileDropzone
												key={"file_upload"}
												title={""}
												fileType={"file"}
												disabled={false}
												fileUploadAction={fileUploadAction}
												fileRemoveAction={removeFileConfirmAction}
												viewFileAction={viewFileAction}
												DropzoneContent={RelatedItemFileZoneContent}
												openFileManagerDialog={fileManagerDialogHandleOpen}
											/>
										</Box>
									</Legend>
								</div>


								<Grid container spacing={1} className={classes.toolMenu}>
									<Grid item xs={12} sm={12} lg={12}>
										<Tooltip title="Create">
											<Fab 
												color="primary"
												size="small"
												onClick={createRelatedItemConfirmAction}
												className={classes.toolMenuBtn}
											>
												<AddIcon />
											</Fab>
										</Tooltip>
									</Grid>
								</Grid>

							</div>
						: ""
					}

				</Grid>
				
				<Grid item xs={12} sm={12} lg={8}>
					<WebViewer 
						property={webViewProps}
					/>
				</Grid>

			</Grid>
		</Fragment>
	)
}


export default CreateRelatedItemForm